import { useTranslation } from 'react-i18next';
import { BiSolidConversation, BiSolidDownload } from 'react-icons/bi';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import Utilities from '../../../utils/index';

const PartnerBaner = () => {
  const { t } = useTranslation();

  const handleDownload = () => {
    const url = 'https://cdn.1cdn.app/application/LOUISEBOT/24120912181650_LouiseBot_Toolkit_3-1.zip';
    const link = document.createElement('a');
    link.href = url;
    link.download = 'LouiseBot_Toolkit_3-1.zip'; // Optional: sets a default filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="tw-w-full tw-p-4 tw-flex tw-gap-4   md:h-32 md:justify-start md:flex-row md:items-center">
      {/* LouiseBot Toolkit */}
      <div className=" tw-flex tw-flex-col md:tw-flex-row tw-grow tw-bg-primary tw-rounded-2xl tw-shadow-md tw-p-3 tw-items-start md:tw-items-center tw-gap-3  tw-self-stretch tw-w-full">
        <div className="tw-hidden md:tw-block tw-w-24 tw-h-24 tw-relative">
          <div className="tw-w-24 tw-h-24 tw-bg-primary tw-rounded-tl-2xl tw-rounded-bl-2xl" />
          <div className="tw-w-16 tw-h-16 tw-left-[15px] tw-top-[15px] tw-absolute tw-bg-blue-700 tw-rounded-lg" />
          <div className="tw-w-12 tw-h-12 tw-left-[23px] tw-top-[23.76px] tw-absolute">
            <img src={Utilities.PartnetBannerLinks.toolkitBox} alt="Toolkit Icon" />
          </div>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-start tw-items-start tw-gap-2 md:tw-pr-4 md:tw-pt-3 md:tw-pb-3.5 tw-grow tw-self-stretch">
          <div className="tw-text-white tw-text-base tw-font-normal tw-font-['Lexend'] tw-pr-2">{t('BusinessPartner/baner/title')}</div>
          <div className="tw-opacity-80 tw-text-white tw-text-xs tw-font-light tw-font-['Lexend']">{t('BusinessPartner/baner/description')}</div>
          <div
            role="button"
            id="btn-partner-download"
            onClick={handleDownload}
            onKeyDown={e => e.key === 'Enter' && handleDownload()}
            tabIndex={0}
            className="tw-rounded-full tw-shadow-sm tw-flex tw-items-center tw-gap-2 tw-overflow-hidden"
          >
            <BiSolidDownload className="tw-text-white tw-w-5 tw-h-5 tw-relative  tw-overflow-hidden" />
            <div className="tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('BusinessPartner/baner/btn')}</div>
          </div>
        </div>
      </div>

      {/* Any Question? Ask Me! */}
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-grow tw-bg-gray-700 tw-rounded-2xl tw-shadow-md tw-p-3 tw-items-start md:tw-items-center tw-gap-3  tw-self-stretch tw-w-full">
        <div className="tw-hidden md:tw-block tw-w-24 tw-h-24 tw-relative">
          <div className="tw-w-24 tw-h-24 tw-bg-gray-700 tw-rounded-tl-2xl tw-rounded-bl-2xl" />
          <img
            className="tw-w-14 tw-h-14 tw-left-[19px] tw-top-[19px] tw-absolute tw-rounded-full"
            src={Utilities.PartnetBannerLinks.alexPlaceholder}
            alt="AI Clone"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-justify-start tw-items-start tw-gap-2 md:tw-pr-4 md:tw-pt-3 md:tw-pb-3.5 tw-grow tw-self-stretch">
          <div className="tw-text-white tw-text-base tw-font-normal tw-font-['Lexend']">{t('BusinessPartner/alex/title')}</div>
          <div className="tw-opacity-80 tw-text-white tw-text-xs tw-font-light tw-font-['Lexend']">{t('BusinessPartner/alex/description')}</div>
          <a
            href={Utilities.PartnetBannerLinks.alexLink}
            target="_blank"
            className="tw-rounded-full tw-shadow-sm tw-flex tw-items-center tw-gap-2 tw-overflow-hidden"
            rel="noreferrer"
          >
            <BiSolidConversation className="tw-text-white tw-w-5 h-5 tw-relative  tw-overflow-hidden" />
            <div className="tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('BusinessPartner/alex/btn')}</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(PartnerBaner);
